export enum ModoConfirmacao {
  MANUAL = "M",
  AUTOMATICO = "A",
}
